import { client } from '@/libs/openApi'

export const getHolidays = async (federalState: string) => {
	const { data } = await client.GET('/ibe/v3/holidays', {
		params: {
			query: { state: federalState },
		},
	})

	return {
		publicHolidays: data?.publicHolidays.map((day) => ({
			...day,
			date: new Date(day.date),
		})),
		schoolHolidays: data?.schoolHolidays.map((day) => ({
			...day,
			date: new Date(day.date),
		})),
	}
}
